import React, { useState, useEffect, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import { detectMob, loadQueryString, numberWithCommas, toMillions, makeGET, makePOST, addDays, returnNumber, makeGETCUSTOM, makeDELETE, makePATCH, extraerNumeros } from "../../helpers/makeRequest";
import { conf } from '../../config/config'
import 'react-phone-number-input/style.css'
import moment from 'moment';
import $ from 'jquery'
import Spinner from 'react-bootstrap/Spinner';
import Select from "react-select";
import { createFilter } from "react-select";
import adslogo from '../../imgs/ads_little.png'
import adnlogo from '../../imgs/adn.png'
import seccionlogo from '../../imgs/seccion_little.ico'
import searchlogo from '../../imgs/search_little.svg'
import facebook from '../../imgs/facebook_f.png'
import Swal from 'sweetalert2';

import { MDBDataTableV5 } from 'mdbreact';

export const UserScreen = () => {
    useEffect(() => {
        getDatos()
    }, [])

    const getDatos = async () => {
        document.getElementById("loading").classList.remove("d-none")
        const datos = await makeGET("report/getProperties")
        console.log(datos)
        setSitiosadn(datos?.data?.ga4.map(v => { return { value: v, label: v } }))
        setFbPages(datos?.data?.metricool.filter(v => v.facebook).map(v => { return { value: v.facebook, label: v.label } }))
        setGoogleAds(datos?.data?.ads.map(v => {
            return {
                value: v.customer_id,
                label: v.campaign_name + " (" + v.customer_id + ")"
            }
        }))
        setSearchConsole(datos?.data?.sc.map(v => { return { value: v.site, label: v.site } }))

        await getUsuarios(datos?.data?.ads)

        document.getElementById("loading").classList.add("d-none")
    }

    const getUsuarios = async (ads) => {
        let { data: { usuarios } } = await makeGET("auth/usersStd")
        usuarios.forEach(element => {
            element.reset_token = (element?.reset_token || "").replace(/[^a-zA-Z0-9]/g, '')
            element.facebook = JSON.parse(element.facebook)
            element.googleads = JSON.parse(element.googleads)
            element.googleads_t = ads.filter(v => element.googleads.find(l => l == v.customer_id))
            element.meta = JSON.parse(element.meta)
            element.search = JSON.parse(element.search)
            element.seccion = JSON.parse(element.seccion)
            element.sitioadn = JSON.parse(element.sitioadn)

            element.buttons =
                <div className="text-center">
                    <button key="update" onClick={e => { handleEdit(element) }} className="btn btn-sm btn-primary mr-1">
                        <i className="fas fa-edit"></i>
                    </button>
                    <button key="delete" onClick={e => { handleDelete(element) }} className="btn btn-sm btn-danger mr-1">
                        <i className="fas fa-trash"></i>
                    </button>
                    {element.reset_token?.length != 0 &&
                        <button key="share" onClick={e => {
                            handleCopyClick(window.location.origin + "/auth/reset?token=" + element.reset_token)
                        }} className="btn btn-sm btn-info">
                            <i className="fa fa-clipboard"></i>
                        </button>
                    }
                </div>
            element.propiedades =
                <div>
                    <p className="font-weight-bold">
                        <img src={adnlogo} height={"20px"} className="mr-2" />
                        {element.sitioadn.length}
                        <img src={seccionlogo} height={"20px"} className="ml-3 mr-2" />
                        {element.seccion.length}
                    </p>
                    <p className="font-weight-bold">
                        <img src={adslogo} height={"20px"} className="mr-2" />
                        {element.googleads.length}
                        <img src={searchlogo} height={"20px"} className="ml-3 mr-2" />
                        {element.search.length}
                    </p>
                </div>
        })



        const data_conf = {
            columns: [
                {
                    label: 'Id Cliente',
                    field: 'idcliente'
                },
                {
                    label: 'Razón Social',
                    field: 'razonsocial'
                },
                {
                    label: 'Email / Id Cliente',
                    field: 'username'
                },
                {
                    label: 'Propiedades',
                    field: 'propiedades',
                },
                {
                    label: '',
                    field: 'buttons'
                }
            ],
            rows: usuarios
        }

        setUsuarios(data_conf)
    }
    const [sitiosadn, setSitiosadn] = useState([])
    const [fbPages, setFbPages] = useState([])
    const [googleads, setGoogleAds] = useState([])
    const [searchConsole, setSearchConsole] = useState([])
    const [seccion, setSeccion] = useState([])

    const [editFlag, setEditFlag] = useState(false)
    const [flag, setFlag] = useState(false)
    const [username, setUsername] = useState("")
    const [idcliente, setIdCliente] = useState("")
    const [razonsocial, setRazonSocial] = useState("")

    const [hostname, setHostname] = useState([])
    const [campaign, setCampaign] = useState([])
    const [site, setSite] = useState([])
    const [fb, setFb] = useState([])
    const [listado, setListado] = useState([])
    const [usuarios, setUsuarios] = useState([])

    const [showOptions, setShowOptions] = useState(false);
    const [showOptions2, setShowOptions2] = useState(false);
    const [showOptions3, setShowOptions3] = useState(false);
    const [showOptions4, setShowOptions4] = useState(false);
    const [showOptions5, setShowOptions5] = useState(false);

    const handleInputChange = useCallback((typedOption) => {
        if (typedOption.length > 2) {
            setShowOptions(true);
        }
        else {
            setShowOptions(false);
        }
    }, []);



    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            ) || /^\d{4,}$/.test(email)
    };

    const handleInputChange2 = useCallback((typedOption) => {
        if (typedOption.length > 2) {
            setShowOptions2(true);
            makeGETCUSTOM("https://sa-api.amarilio.net/", "searchBc?term=" + typedOption).then(v => {
                setSeccion([...v.data.map(v => { return { label: v, value: extraerNumeros(v) } })])
            }).catch(e => console.log(e))
        }
        else {
            setShowOptions2(false);
        }
    }, []);

    const handleInputChange3 = useCallback((typedOption) => {
        if (typedOption.length > 2) {
            setShowOptions3(true);
        }
        else {
            setShowOptions3(false);
        }
    }, []);

    const handleInputChange4 = useCallback((typedOption) => {
        if (typedOption.length > 2) {
            setShowOptions4(true);
        }
        else {
            setShowOptions4(false);
        }
    }, []);

    const handleInputChange5 = useCallback((typedOption) => {
        if (typedOption.length > 2) {
            setShowOptions5(true);
        }
        else {
            setShowOptions5(false);
        }
    }, []);

    const resetForm = () => {
        setUsername("")
        setIdCliente("")
        setRazonSocial("")
        setHostname([])
        setListado([])
        setCampaign([])
        setSite([])
        setFlag(false)
        setEditFlag(false)
    }

    const [isCopied, setIsCopied] = useState(false);

    const handleCopyClick = async (textToCopy) => {
        try {
            await navigator.clipboard.writeText(textToCopy)
            setIsCopied(true)
            setTimeout(() => setIsCopied(false), 1000)
        } catch (err) {
            console.error('Failed to copy text: ', err)
        }
    }

    const handleSubmit = async () => {
        try {
            const payload = {
                username,
                sitioadn: hostname.map(v => v.value),
                seccion: listado.map(v => v.value),
                facebook: fb.map(v => v.value),
                meta: [],
                googleads: campaign.map(v => v.value),
                search: site.map(v => v.value),
                razonsocial,
                idcliente
            }
            document.getElementById("loading").classList.remove("d-none")
            const resp = editFlag ? await makePATCH("auth/edit", payload) : await makePOST("auth/register", payload)
            await getUsuarios(googleads)

            if (editFlag) {
                Swal.fire('Éxito!', 'Usuario editado correctamente.', 'success')
            } else {
                Swal.fire({
                    title: "Éxito!",
                    html: `
                    <p>Usuario registrado con la contraseña: ${resp.data.password}</p>
                    <p>Y el link para inicio de sesión</p>
                    <a href="javascript:function() { return false; }" id="copy">
                        ${window.location.origin + "/auth/reset?token=" + resp.data.reset_token}
                    </a>
                    `,
                    didOpen: () => {
                        const boton = document.getElementById('copy')
                        if (boton) {
                            boton.addEventListener('click', () => {
                                handleCopyClick(window.location.origin + "/auth/reset?token=" + resp.data.reset_token)
                                Swal.close();
                            });
                        }
                    },
                    icon: 'success',
                    showCancelButton: false,
                })
            }

            resetForm()
            document.getElementById("loading").classList.add("d-none")
        } catch (e) {
            console.log(e)
            document.getElementById("loading").classList.add("d-none")
            Swal.fire('Error', 'Hubo un error.', 'error')
        }
    }

    const handleEdit = (el) => {
        setEditFlag(true)
        setFlag(false)
        setUsername(el.username)
        setRazonSocial(el.razonsocial)
        setIdCliente(el.idcliente)
        setHostname(el.sitioadn.map(v => { return { label: v, value: v } }))
        setListado(el.seccion.map(v => { return { label: v, value: v } }))
        setSite(el.search.map(v => { return { label: v, value: v } }))
        setFb(el.facebook.map(v => { return { label: v, value: v } }))
        setCampaign(el.googleads_t.map(v => {
            return {
                value: v.customer_id,
                label: v.campaign_name + " (" + v.customer_id + ")"
            }
        }))

        /*const findedAds = googleads.filter(v => el.googleads.includes(v.value))
        console.log(el, [...new Set(findedAds.map(v => v.label))])*/
    }

    const handleDelete = async (el) => {
        Swal.fire("Atención", "¿Estás seguro que quieres eliminar el registro seleccionados?", "warning")
            .then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        document.getElementById("loading").classList.remove("d-none")
                        const { username } = el
                        const resp = await makeDELETE("auth/delete", { username })
                        await getUsuarios(googleads)
                        Swal.fire('Éxito!', 'Usuario eliminado correctamente', 'success')
                        document.getElementById("loading").classList.add("d-none")
                    } catch (e) {
                        console.log(e)
                        document.getElementById("loading").classList.add("d-none")
                        Swal.fire('Error', 'Hubo un error.', 'error')
                    }
                }
            })
    }

    return (
        <div className="row mt-3 p-3">
            <div className="loading d-none text-center" id="loading">
                <div className="d-flex justify-content-center">
                    <p className="m-0"><Spinner animation="border" role="status" variant="dark"></Spinner></p>
                </div>
                <div className="d-flex justify-content-center">
                    <p style={{ color: "black", zIndex: 10001 }}>Cargando</p>
                </div>
            </div>
            {(editFlag || flag) &&
                <>
                    <div className="col-12 col-md-6 text-center mb-3">
                        <p className="font-weight-bold">
                            Email / Id Cliente
                        </p>
                        <input className="form-control" type="text" value={username}
                            onChange={(e) => {
                                setUsername(e.target.value)
                            }}
                        />
                    </div>
                    <div className="col-12 col-md-6 text-center mb-3">
                        <p className="font-weight-bold">
                            Id Cliente
                        </p>
                        <input className="form-control" type="text" value={idcliente}
                            onChange={(e) => {
                                setIdCliente(e.target.value)
                            }}
                        />
                    </div>
                    <div className="col-12 col-md-6 text-center mb-3">
                        <p className="font-weight-bold">
                            Razon Social
                        </p>
                        <input className="form-control" type="text" value={razonsocial}
                            onChange={(e) => {
                                setRazonSocial(e.target.value)
                            }}
                        />
                    </div>
                    <div className="col-12 col-md-6 text-center mb-3">
                        <p className="font-weight-bold">
                            Logo (opcional)
                        </p>
                        <div class="input-group mb-3">
                            <input type="file" class="form-control" id="inputGroupFile02" accept="image/*"/>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 text-center mb-3">
                        <p className="font-weight-bold">
                            Sitio ADN
                            <img src={adnlogo} height={"20px"} className="ml-2" />
                        </p>
                        <Select
                            options={(showOptions || sitiosadn.length < 1000) ? sitiosadn : []}
                            autoFocus={false}
                            className=""
                            id="hosts"
                            isMulti={true}
                            style={{ width: "100%", paddingTop: "1rem!important" }}
                            isSearchable={true}
                            noOptionsMessage={({ inputValue }) => "Escribe 2 o más letras para filtrar"}
                            onInputChange={handleInputChange}
                            value={hostname}
                            filterOption={createFilter({ ignoreAccents: false })}
                            onChange={(e) => {
                                setHostname(e)
                            }}
                        />
                    </div>
                    <div className="col-12 col-md-6 text-center mb-3">
                        <p className="font-weight-bold">
                            Sección Amarilla
                            <img src={seccionlogo} height={"20px"} className="ml-2" />
                        </p>
                        <Select
                            options={(showOptions2 || seccion.length < 1000) ? seccion : []}
                            autoFocus={false}
                            className=""
                            id="hosts"
                            value={listado}
                            isMulti={true}
                            style={{ width: "100%", paddingTop: "1rem!important" }}
                            isSearchable={true}
                            noOptionsMessage={({ inputValue }) => "Escribe 2 o más letras para filtrar"}
                            onInputChange={handleInputChange2}
                            filterOption={createFilter({ ignoreAccents: false })}
                            onChange={(e) => {
                                setListado(e)
                            }}
                        />
                    </div>
                    <div className="col-12 col-md-6 text-center mb-3">
                        <p className="font-weight-bold">
                            Google Ads
                            <img src={adslogo} height={"20px"} className="ml-2" />
                        </p>
                        <Select
                            options={(showOptions3 || googleads.length < 1000) ? googleads : []}
                            autoFocus={false}
                            className=""
                            id="hosts"
                            isMulti={true}
                            style={{ width: "100%", paddingTop: "1rem!important" }}
                            isSearchable={true}
                            noOptionsMessage={({ inputValue }) => "Escribe 2 o más letras para filtrar"}
                            onInputChange={handleInputChange3}
                            value={campaign}
                            filterOption={createFilter({ ignoreAccents: false })}
                            onChange={(e) => {
                                setCampaign(e)
                            }}
                        />
                    </div>
                    <div className="col-12 col-md-6 text-center mb-3">
                        <p className="font-weight-bold">
                            Search Console
                            <img src={searchlogo} height={"20px"} className="ml-2" />
                        </p>
                        <Select
                            options={(showOptions4 || searchConsole.length < 1000) ? searchConsole : []}
                            autoFocus={false}
                            className=""
                            id="hosts"
                            isMulti={true}
                            style={{ width: "100%", paddingTop: "1rem!important" }}
                            isSearchable={true}
                            noOptionsMessage={({ inputValue }) => "Escribe 2 o más letras para filtrar"}
                            onInputChange={handleInputChange4}
                            value={site}
                            filterOption={createFilter({ ignoreAccents: false })}
                            onChange={(e) => {
                                setSite(e)
                            }}
                        />
                    </div>
                    <div className="col-12 col-md-6 text-center mb-3">
                        <p className="font-weight-bold">
                            Facebook
                            <img src={facebook} height={"20px"} className="ml-2" />
                        </p>
                        <Select
                            options={(showOptions5 || fbPages.length < 1000) ? fbPages : []}
                            autoFocus={false}
                            className=""
                            id="hosts"
                            isMulti={true}
                            style={{ width: "100%", paddingTop: "1rem!important" }}
                            isSearchable={true}
                            noOptionsMessage={({ inputValue }) => "Escribe 2 o más letras para filtrar"}
                            onInputChange={handleInputChange5}
                            value={fb}
                            filterOption={createFilter({ ignoreAccents: false })}
                            onChange={(e) => {
                                setFb(e)
                            }}
                        />
                    </div>
                </>
            }
            <div className="col-12">
                <div className="row">
                    <div className="col-4"></div>
                    <div className="col-4 text-center">
                        {(flag || editFlag) &&
                            <button className={"btn font-weight-bold ml-auto mr-auto " + (flag ? "btn-success" : "btn-primary")}
                                onClick={() => {
                                    handleSubmit()
                                }}
                                disabled={!validateEmail(username) || razonsocial.length == 0 || idcliente.length == 0}>
                                {flag ? "Guardar" : "Modificar"}
                            </button>
                        }
                    </div>
                    <div className="col-4 text-right">
                        <button className={"btn font-weight-bold ml-auto " + ((flag || editFlag) ? "btn-danger" :
                            (editFlag ? "btn-primary" : "btn-success"))}
                            onClick={() => {
                                if ((flag || editFlag)) {
                                    setFlag(false)
                                    setEditFlag(false)
                                    resetForm()
                                } else {
                                    setFlag(true)
                                }
                            }}>
                            {(flag || editFlag) ? "Cancelar" : (editFlag ? "Modificar" : "Añadir nuevo")}
                        </button>
                    </div>
                </div>
            </div>
            <div className={"col-12" + ((editFlag || flag) ? " border-top mt-3" : "")}>
                <MDBDataTableV5
                    striped
                    responsiveSm
                    responsive
                    responsiveMd
                    responsiveLg
                    responsiveXl
                    hover
                    entriesLabel="Por página"
                    pagingTop
                    infoLabel={["Página", " - ", "de", "registros"]}
                    paginationLabel={["Anterior", "Siguiente"]}
                    searchLabel="Buscar..."
                    className="mdb"
                    searchTop
                    searchBottom={false}
                    noBottomColumns
                    data={usuarios}
                />
            </div>
        </div>
    );
}
